import { CONTINUE_LEAD_IN_SECONDS } from './constants'
import { parseTimecodeToSeconds } from './timecode'

/**
 * Build a consumer web-app deep link for a transcript chunk (Mosaic continue-watching lead-in).
 */
export function buildWatchUrl (
  webAppBase: string,
  contentPath: string | null | undefined,
  startTimecode: string | null | undefined,
): string | null {
  if (!webAppBase || !contentPath) {
    return null
  }
  const rawStart = parseTimecodeToSeconds(startTimecode) ?? 0
  const startSec = Math.max(0, rawStart - CONTINUE_LEAD_IN_SECONDS)
  const path = contentPath.startsWith('/') ? contentPath : `/${contentPath}`
  const base = webAppBase.replace(/\/$/, '')
  return `${base}${path}?startAt=${Math.floor(startSec)}&fullplayer=feature`
}
